export function extractYouTubeVideoId(YouTubeUrl: string): string {
    /*This regex checks the following:
    1. Starts with http:// or https://
    2. Has a .com domain
    3. Followed by "/watch?", "/v", or "/live" (with optional trailing slash)
    4. Has an group of numbers (ID) at the end exactly 11 characters long
    */
    const youtubeVideoIdMatch =
        /^https?:\/\/(?:www\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|v\/|live\/|embed\/)|youtu\.be\/|youtube\.googleapis\.com\/v\/)([0-9a-zA-Z_-]{11})(?:[&?].*)?$/.exec(
            YouTubeUrl
        );

    if (youtubeVideoIdMatch === null || !youtubeVideoIdMatch[1]) {
        throw new Error(`Unable to extract the youtube video ID from configuration: ${YouTubeUrl}`);
    }

    return youtubeVideoIdMatch[1];
}
